// src/components/orders/wizard/WizardHeader.js
import React from 'react';
import { Wifi, WifiOff, Clock, Save, Trash2 } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';
import OfflineAuthIndicator from '../../auth/OfflineAuthIndicator';

const WizardHeader = ({ 
  steps, 
  currentStep, 
  validSteps, 
  completedSteps, 
  onStepClick,
  isOnline,
  lastSaved,
  pendingSyncCount,
  onClearDraft 
}) => {
  const currentStepData = steps.find(step => step.id === currentStep);
  const { isOfflineMode, lastOnlineLogin } = useAuth();

  return (
    <div className="border-b border-gray-200 shadow-sm overflow-hidden" style={{backgroundColor: '#fcfbd6'}}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-4 overflow-x-auto">
          {/* Info step corrente */}
          <div className="flex items-center space-x-2 sm:space-x-4 flex-shrink-0">
            <div className="flex items-center space-x-2 sm:space-x-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{backgroundColor: '#c48f75'}}>
                <span className="text-lg font-semibold text-white">
                  {currentStep}
                </span>
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">
                  {currentStepData?.title || 'Nuovo Ordine'}
                </h1>
                <p className="text-sm text-gray-600">
                  {currentStepData?.description || 'Crea un nuovo ordine'}
                </p>
              </div>
            </div>
          </div>

          {/* Indicatori stato PWA */}
          <div className="flex items-center space-x-2 sm:space-x-3 lg:space-x-4 flex-shrink-0">
            {/* Indicatore auth offline */}
            <OfflineAuthIndicator 
              isOfflineMode={isOfflineMode}
              lastOnlineLogin={lastOnlineLogin}
            />
            
            {/* Stato connessione */}
            <div className={`hidden sm:flex items-center space-x-2 px-3 py-2 rounded-lg ${
              isOnline 
                ? 'bg-green-50 text-green-700 border border-green-200'
                : 'bg-orange-50 text-orange-700 border border-orange-200'
            }`}>
              {isOnline ? (
                <Wifi className="w-4 h-4" />
              ) : (
                <WifiOff className="w-4 h-4" />
              )}
              <span className="text-sm font-medium">
                {isOnline ? 'Online' : 'Offline'}
              </span>
            </div>

            {/* Ordini pendenti */}
            {isOnline && pendingSyncCount > 0 && (
              <div className="hidden md:flex items-center space-x-2 px-3 py-2 bg-blue-50 text-blue-700 border border-blue-200 rounded-lg">
                <Clock className="w-4 h-4" />
                <span className="text-sm font-medium">
                  {pendingSyncCount} da sincronizzare
                </span>
              </div>
            )}

            {/* Ultimo salvataggio */}
            {lastSaved && (
              <div className="hidden lg:flex items-center space-x-2 px-3 py-2 bg-gray-50 text-gray-600 border border-gray-200 rounded-lg">
                <Save className="w-4 h-4" />
                <span className="text-sm">
                  Salvato {new Date(lastSaved).toLocaleTimeString('it-IT', { 
                    hour: '2-digit', 
                    minute: '2-digit' 
                  })}
                </span>
              </div>
            )}
            
            {/* Pulsante cancella bozza - solo se c'è una bozza attiva */}
            {onClearDraft && (
              <button
                onClick={() => {
                  if (window.confirm('Vuoi cancellare la bozza corrente e ricominciare da capo?')) {
                    onClearDraft();
                  }
                }}
                className="flex items-center space-x-2 px-2 py-1 text-white border rounded-lg transition-colors text-sm custom-button-hover wizard-button-border"
                style={{backgroundColor: '#c48f75'}}
                title="Cancella bozza e ricomincia"
              >
                <Trash2 className="w-3 h-3" />
                <span className="text-xs font-medium">Reset</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WizardHeader;